import { EXPO_PUBLIC_IAM_FE_BASE_URL } from '@env';

export const EXTERNAL_URLS = {
  login: EXPO_PUBLIC_IAM_FE_BASE_URL,
};
